import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel } from '../../../IconLabel';

import classNames from 'classnames';
import classes from '../InlineTools.module.scss';

interface SuperscriptProps {
  editor: Editor;
}

export const Superscript: FunctionComponent<SuperscriptProps> = ({ editor }) => {
  const { t } = useTranslation();

  const { isActive, canToggle } = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isActive: editor.isActive('superscript'),
      canToggle: editor.can().chain().focus().toggleSuperscript().run(),
    }),
  });

  return (
    <IconLabel
      iconId={'superscript'}
      iconSize={16}
      ariaLabel={t('richTextEditor.tool-names-superscript')}
      onClick={() => editor.chain().focus().toggleSuperscript().run()}
      disabled={!canToggle}
      className={classNames(classes['inline-tools__item'], {
        [classes['inline-tools__item--active']]: isActive,
        [classes['inline-tools__item--disabled']]: !canToggle,
      })}
    />
  );
};
